export const SET_TRADEIN = 'SET_TRADEIN'
export const RESET_TRADE_IN = 'RESET_TRADE_IN'
export const COORDINATE_ZIP_CODE = 'COORDINATE_ZIP_CODE'
export const SET_POINT_OF_SALES = 'SET_POINT_OF_SALES'
export const SET_CAR_INFORMATIONS = 'SET_CAR_INFORMATIONS'
export const RESET_CAR_INFORMATIONS = 'RESET_CAR_INFORMATIONS'

export const setTradeIn = tradeIn => ({
  type: SET_TRADEIN,
  tradeIn
})

export const setPointOfSales = tradeIn => ({
  type: SET_POINT_OF_SALES,
  tradeIn
})

export const resetTradeIn = keepPointOfSale => ({
  type: RESET_TRADE_IN,
  keepPointOfSale
})

export const setCarInformations = carInformations => ({
  type: SET_CAR_INFORMATIONS,
  carInformations
})

export const resetCarInformations = () => ({
  type: RESET_CAR_INFORMATIONS,
})
